// extracted by mini-css-extract-plugin
export default {"spacer":"Spacer_spacer__r7SMT"};